export default __webpack_public_path__ + "static/media/arrow_eval_up.78357845.svg";